import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


interface CardSkeletonProps {
  cards: number;
}

const CardSkeleton = ({ cards }: CardSkeletonProps) => {
  const skeletonCards = Array.from({ length: cards }).map((_, index) => (
    <div key={index} className='card-skeleton'>
      <div className='left-col'>
        <Skeleton circle width={20} height={20} />
      </div>
      <div className='right-col'>
        <Skeleton count={5} />
      </div>
    </div>
  ));

  return <>{skeletonCards}</>;
};

export default CardSkeleton;








